import React, { useContext } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import LTI3LoginComponent from "./components/LTI3LoginComponent";
import LoggingSystem from "./components/LoggingSystem";
import SSOLoginComponent from "./components/SSOLoginComponent";
import { Spin } from "./components/standardization/YuJaLoading";
import Layout from "./layouts/Layout";
import IntegrationPageParent from "./pages/Admin/IntegrationPage/IntegrationPageParent";
import CourseContentPage from "./pages/CourseContentPage/CourseContentPage";
import CreateQuizPageParent from "./pages/CreateQuizPage/CreateQuizPageParent";
import EditQuizPage from "./pages/CreateQuizPage/EditQuizPage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import GradeBookPage from "./pages/GradeBookPage/GradeBookPage";
import GuestLoginPage from "./pages/GuestLoginPage/GuestLoginPage";
import StudentDashboard from "./pages/HomePage/StudentDashboard";
import JoinQuizParentNew from "./pages/JoinQuizPage/JoinQuizParentNew";
import OverallResultsPage from "./pages/JoinQuizPage/OverallResultsPage";
import D2LAuthTokenPage from "./pages/LTI/D2LAuthTokenPage";
import EmbeddedPollGuide from "./pages/LTI/EmbeddedPollGuide";
import OpenInNewTab from "./pages/LTI/OpenInNewTab";
import ForgotPasswordPage from "./pages/LoginPage/ForgotPasswordPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import PasswordResetPage from "./pages/LoginPage/PasswordResetPage";
import ManageCoursesPage from "./pages/ManageCoursesPage/ManageCoursesPage";
import FeedbackPage from "./pages/ManagePollsPage/FeedbackPage";
import ManagePollsPage from "./pages/ManagePollsPage/ManagePollsPage";
import ManageUserPage from "./pages/ManageUserPage/ManageUserPage";
import LTIDeepLinkingAutoSubmitForm from "./pages/MediaChooser/LTIDeepLinkingAutoSubmitForm";
import PollChooser from "./pages/MediaChooser/PollChooser";
import MobileMapView from "./pages/MobileMapView/MobileMapView";
import MobileResultPage from "./pages/MobileResultPage/MobileResultPage";
import NoMatchPage from "./pages/NoMatchPage/NoMatchPage";
import PPTEditActivityPage from "./pages/PPTPlugin/PPTEditActivityPage";
import PPTInsertCompletedPage from "./pages/PPTPlugin/PPTInsertCompletedPage";
import PPTInsertWaitingPage from "./pages/PPTPlugin/PPTInsertWaitingPage";
import PPTLayout from "./pages/PPTPlugin/PPTLayout";
import PPTPollDetailPage from "./pages/PPTPlugin/PPTPollDetailPage";
import PPTPollsPage from "./pages/PPTPlugin/PPTPollsPage";
import PPTSplashScreen from "./pages/PPTPlugin/PPTSplashScreen";
import PlatformSetting from "./pages/PlatformSetting/PlatformSetting";
import ViewerSettings from "./pages/PlatformSetting/ViewerSettings";
import PresentationPage from "./pages/PresentationPage/PresentationPage";
import DisabledActivityPage from "./pages/DisabledActivityPage/DisabledActivityPage";
import EditQuestionProfilePage from "./pages/QuestionProfilesPage/EditQuestionProfilePage";
import QuestionBankPage from "./pages/QuestionProfilesPage/QuestionBankPage";
import MobileSSOLoginPage from "./pages/SAML/MobileSSOLoginPage";
import ScanQRPage from "./pages/ScanQRPage/ScanQRPage";
import ViewEnrolledCoursesPage from "./pages/ViewEnrolledCoursesPage/ViewEnrolledCoursesPage";
import ViewTakenPollsPage from "./pages/ViewTakenPollsPage/ViewTakenPollsPage";
import ToastCollection from "./public/toast/ToastCollection";
import {YuJaGlobalState} from "./utils/LoadingContext";
import CreatorWarning from "./pages/LoginPage/CreatorWarning";
import { ROLES } from "./utils/constants";
import RecycleBinPage from "./pages/ManagePollsPage/RecycleBinPage";
import ReportInstPage from "./pages/Report/ReportInstPage";
import ReportCoursePage from "./pages/Report/ReportCoursePage";
import ReportActivityPage from "./pages/Report/ReportActivityPage";
import ReportStandalonePage from "./pages/Report/ReportStandalonePage";
import PPTCreateActivityPage from "./pages/PPTPlugin/PPTCreateActivityPage";
import ReleaseActivityPage from "./pages/ReleaseActivityPage/ReleaseActivityPage";
import SlideInstructionTemplate from "./pages/PPTPlugin/SlideInstructionTemplate";
import SlideQuestionTemplate from "./pages/PPTPlugin/SlideQuestionTemplate";
import SlideTemplate from "./pages/PPTPlugin/SlideTemplate";
import PPTInsertWaitingNewPage from "./pages/PPTPlugin/PPTInsertWaitingNewPage";
import SlideOverallTemplate from "./pages/PPTPlugin/SlideOverallTemplate";
import LicensesPage from "./pages/License/LicensesPage";
import ReportUsagePage from "./pages/Report/ReportUsagePage";
import CSMRedirectComponent from "./pages/CSM/CSMRedirectComponent";
import MarketplacePage from "./pages/MarketPlace/MarketplacePage";

function App() {
    const {loading} = useContext(YuJaGlobalState);


    return (
        <>
            <ToastCollection />
            <LoggingSystem />
            <Switch>
                <Route exact path="/"
                       render={() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                               <LoginPage />
                           </Spin>)}
                />

                <Route exact path="/licenses"
                   render={() => (
                           <LicensesPage />
                       )}
                />

                <Route exact path="/home"
                       render={() => (
                           <Layout
                               pageRoles={Object.values(ROLES).map(r => r.value).filter(i => i !== ROLES.ANONYMOUS.value)}
                               flex={true}
                               hasPin={true}
                           >
                               <DashboardPage/>
                           </Layout>
                       )}
                />

                <Route exact path="/reset/:userName/:resetCode"
                       render={() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                               <PasswordResetPage />
                           </Spin>)}
                />

                <Route exact path="/forgot"
                       render={() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                               <ForgotPasswordPage />
                           </Spin>)}
                />

                <Route exact path="/join/:pollUniqueCode"
                       render = {() => (
                           <Layout pageRoles={[ROLES.VIEWER.value, ROLES.ANONYMOUS.value]}>
                               <JoinQuizParentNew/>
                           </Layout>
                       )}
                />

                <Route exact path="/scan"
                       render = {() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                               <ScanQRPage/>
                           </Spin>
                       )}
                />

                <Route exact path="/qr/:pollUniqueCode?"
                       render = {() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                                <GuestLoginPage />
                           </Spin>
                       )}
                />


                <Route exact path="/home/sso"
                       render={() => (
                           <SSOLoginComponent />
                       )}
                />

                <Route exact path="/csm/redirect"
                       render={() => (
                           <CSMRedirectComponent />
                       )}
                />

                <Route exact path="/sso/:endType/:result"
                       render={() => (
                           <MobileSSOLoginPage />
                       )}
                />

                <Route exact path="/home/lti"
                       render={() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                               <LTI3LoginComponent />
                           </Spin>
                       )}
                />

                <Route exact path="/home/create"
                       render={() => (
                           <Layout flex={true} hasPin={true}>
                               <StudentDashboard show={"nav"} />
                           </Layout>)}
                />

                <Route exact path="/create"
                       render={() => (
                           <Layout>
                                <CreateQuizPageParent />
                           </Layout>)}
                />

                <Route exact path="/edit/:pollKey/:pollCode"
                       render={() => (
                               <Layout >
                                   <EditQuizPage />
                               </Layout>
                       )}
                />

                <Route exact path="/warning"
                       render={() => (
                           <>
                                   <CreatorWarning />
                           </>)}
                />

                <Route exact path="/results"
                       render={() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                               <OverallResultsPage />
                           </Spin>
                       )}
                />



                <Route exact path="/admin/integration"
                       render={() => (
                           <Layout hasPin={true}>
                               <IntegrationPageParent />
                           </Layout>)}
                />

                <Route exact path="/admin/platformsetting"
                       render={() => (
                           <Layout hasPin={true}>
                               < PlatformSetting/>
                           </Layout>)}
                />
                <Route exact path="/student/settings"
                       render={() => (
                           <Layout hasPin={true} pageRoles={[ROLES.VIEWER.value]}>
                               <ViewerSettings/>
                           </Layout>)}
                />

                <Route exact path="/course/content/:courseId"
                       render={() => (
                           <Layout hasPin={true}>
                               <CourseContentPage />
                           </Layout>)}
                />

                <Route exact path="/poll/user/"
                       render={() => (
                           <Layout flex={false} hasPin={true}>
                               <ManagePollsPage />
                           </Layout>
                       )}
                />

                <Route exact path="/poll/choose/:courseId"
                       render={() => (
                           <Spin size="large" wrapperClassName="globalSpin" spinning={loading} tip="Loading...">
                               <PollChooser />
                           </Spin>
                       )}
                />

                <Route exact path="/lti/deeplink/form"
                       render={() => (
                           <LTIDeepLinkingAutoSubmitForm />
                       )}
                />

                <Route exact path="/questionBank/edit/:questionProfileId"
                       render={() => (
                           <Layout>
                               <EditQuestionProfilePage />
                           </Layout>
                       )}
                />


                <Route exact path="/gradeBook"
                       render={() => (
                           <Layout hasPin={true}>
                               <GradeBookPage />
                           </Layout>
                       )}
                />

                <Route exact path="/student/polls"
                       render={() => (
                           <Layout flex={true} hasPin={true} pageRoles={[ROLES.VIEWER.value]}>
                               <ViewTakenPollsPage />
                           </Layout>
                       )}
                />

                <Route exact path="/student/courses"
                       render={() => (
                           <Layout flex={true} hasPin={true} pageRoles={[ROLES.VIEWER.value]}>
                               <ViewEnrolledCoursesPage/>
                           </Layout>
                       )}
                />

                <Route exact path="/course/user/"
                       render={() => (
                           <Layout flex={false} hasPin={true}>
                               <ManageCoursesPage />
                           </Layout>
                       )}
                />

                <Route exact path="/course/user/create"
                       render={() => (
                           <Layout flex={false} hasPin={true}>
                               <ManageCoursesPage show={"nav"}/>
                           </Layout>
                       )}
                />

                {/* <Route exact path="/poll/published/:pollKey/:pollCode"
                       render={() => (
                           <Layout width={"0%"} hasPin={true}>
                               <PublishedPollPage />
                           </Layout>
                       )}
                /> */}

                <Route exact path="/poll/share/:pollKey/:pollCode"
                       render={() => (
                           <Layout  hasPin={true}>
                               {/*<SharePollPage />*/}
                               <ReleaseActivityPage />
                           </Layout>
                       )}
                />

                <Route exact path="/disabled/poll-survey"
                    render={() => (
                        <Layout flex={false} hasPin={true}>
                            <DisabledActivityPage />
                        </Layout>
                    )}
                />

                <Route exact path="/poll/feedback/:pollKey/:pollCode"
                       render={() => (
                           <Layout width={"0%"} hasPin={true}>
                               <FeedbackPage />
                           </Layout>
                       )}
                />

                <Route exact path="/recyclebin"
                       render={() => (
                           <Layout width={"0%"} hasPin={true}>
                               <RecycleBinPage />
                           </Layout>
                       )}
                />

                < Route exact path="/questionBank"
                       render={() => (
                           <Layout width={"0%"} hasPin={true}>
                               <QuestionBankPage />
                           </Layout>
                       )}
                />

                <Route exact path="/users"
                       render={() => (
                           <Layout flex={true} hasPin={true}>
                               <ManageUserPage />
                           </Layout>
                       )}
                />
                <Route exact path="/report/usage"
                       render={() => (
                           <Layout  hasPin={true}>
                               <ReportUsagePage />
                           </Layout>
                       )}
                />

                <Route exact path="/report/inst"
                       render={() => (
                           <Layout  hasPin={true}>
                               <ReportInstPage />
                           </Layout>
                       )}
                />

                <Route exact path="/report/user"
                       render={() => (
                           <Layout hasPin={true}>
                               <ReportInstPage isUserWise={true} />
                           </Layout>
                       )}
                />

                <Route exact path="/report/user-standalone"
                       render={() => (
                           <Layout hasPin={true}>
                               <ReportStandalonePage isUserWise={true}/>
                           </Layout>
                       )}
                />

                <Route exact path="/report/standalone"
                       render={() => (
                           <Layout hasPin={true}>
                               <ReportStandalonePage />
                           </Layout>
                       )}
                />
                <Route exact path="/report/course/:courseId"
                       render={() => (
                           <Layout  hasPin={true}>
                               <ReportCoursePage />
                           </Layout>
                       )}
                />

                <Route exact path="/report/activity/:pollKey/:pollCode"
                       render={() => (
                           <Layout hasPin={true}>
                               <ReportActivityPage />
                           </Layout>
                       )}
                />



                <Route exact path="/presentation/:pollCode/:serialNo?"
                       render={() => (
                           <PresentationPage/>
                       )}
                />

                <Route exact path="/presentation/slide/:pollKey/:pollCode/:shareMode?/template"
                       render={() => (
                           <SlideTemplate/>
                       )}
                />

                <Route exact path="/presentation/instructionSlide/:pollKey/:pollCode/template"
                       render={() => (
                           <SlideInstructionTemplate/>
                       )}
                />
                <Route exact path="/presentation/overallSlide/:pollKey/:pollCode/template"
                       render={() => (
                           <SlideOverallTemplate/>
                       )}
                />

                <Route exact path="/presentation/questionSlide/:pollKey/:pollCode/:serialNo/template"
                       render={() => (
                           <SlideQuestionTemplate/>
                       )}
                />
                <Route exact path="/mobile/map/:lat/:lng/:rad"
                        render={() => (
                            <MobileMapView/>
                       )}
                />
                <Route exact path="/mobile/result/:pollKey/:pollCode/:serialNo"
                       render={() => (
                           <MobileResultPage/>
                       )}
                />
                <Route exact path="/portal"
                        render={() => (
                            <OpenInNewTab/>
                        )}
                />
                <Route exact path="/lti/:pollCode/guide"
                       render = {() => (
                           <>
                               <Layout pageRoles={[ROLES.VIEWER.value, ROLES.ANONYMOUS.value]}>
                                   <EmbeddedPollGuide/>
                               </Layout>
                           </>
                       )}
                />
                <Route exact path="/api/d2l/success"
                       render = {() => (
                           <>
                            <D2LAuthTokenPage/>
                           </>
                       )}
                />
                <Route exact path="/PPT/:appId/polls"
                       render={() => (
                           <PPTLayout>
                               <PPTPollsPage/>
                           </PPTLayout>
                       )}
                />
                <Route exact path="/PPT/:appId/polls/:pollKey/:pollCode?/detail"
                       render={() => (
                           <PPTLayout>
                               <PPTPollDetailPage/>
                           </PPTLayout>
                       )}
                />
                <Route exact path="/PPT/:appId/poll/:pollType/create"
                       render={() => (
                           <PPTLayout>
                               <PPTCreateActivityPage/>
                           </PPTLayout>
                       )}
                />

                <Route exact path="/PPT/:appId/poll/:pollKey/edit"
                       render={() => (
                           <PPTLayout>
                               <PPTEditActivityPage/>
                           </PPTLayout>
                       )}
                />


                <Route exact path="/PPT/:appId/:pollType?/waiting"
                       render={() => (
                           <PPTLayout>
                               <PPTInsertWaitingPage/>
                           </PPTLayout>
                       )}
                />

                <Route exact path="/PPT/:appId/:runningApp/inserting"
                       render={() => (
                           <PPTLayout>
                               <PPTInsertWaitingNewPage/>
                           </PPTLayout>
                       )}
                />

                <Route exact path="/PPT/:appId/:pollType?/:from?/completed"
                       render={() => (
                           <PPTLayout>
                               <PPTInsertCompletedPage/>
                           </PPTLayout>
                       )}
                />
                <Route exact path="/PPT/splash"
                       render={() => (
                           <PPTSplashScreen/>
                       )}
                />

                <Route exact path="/marketplace"
                       render={() => (
                           <Layout flex={true} hasPin={true}>
                               <MarketplacePage/>
                           </Layout>
                       )}
                />
                <Route component={NoMatchPage} />
            </Switch>

        </>

    );
}

export default App;
